import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { clearSuccessModal } from '../../../../actions/uiLogic';
import VerificationModal from './VerificationModal';

const mapStateToProps = state => {
  const successDetails = _get(state, 'uiLogic.message', {});
  return {
    isVisible: _get(successDetails, 'show', false),
    title: _get(successDetails, 'title', 'Success'),
    subtitle: _get(successDetails, 'subtitle', ''),
    iconType: _get(successDetails, 'type', 'timeFill'),
  };
};

const mapDispatchToProps = dispatch => ({
  clearSuccessModal: () => dispatch(clearSuccessModal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VerificationModal);
